import { CreativeSetupFlowPageModel } from 'containers/Creatives/CreativeSetupFlow/CreativeSetupFlowPageModelInterface';
import { RichProductNativeFormModel } from './RichProductNativeFormModel';
import { Product } from 'core/product/Product';

export class WebRichProductNativeFormModel extends RichProductNativeFormModel {

  constructor (
    flowPageModel: CreativeSetupFlowPageModel,
    products: Product[] = []
  ) {
    super(flowPageModel, products, [{ width: 2440, height: 250 }]);
  }
}
